import React from 'react';
import GeneralInformation from '../Views/GeneralInformation';
import ProgramCaseStatements from '../Views/ProgramCaseStatements';
import GovernanceStaff from '../Views/GovernanceStaff';
import FiscalRegulatory from '../Views/FiscalRegulatory';
import Partnerships from '../Views/Partnerships';
import AwardsRecognitionPublicity from '../Views/AwardsRecogPublicity';
import Attachments from '../Views/Attachments';
import NotesVerbiage from '../Views/NotesVerbiage';
import Download from '../Views/Download';

export default ({
  client,
  fetchData,
}: {
  client: any;
  fetchData: () => void;
}) => [
  {
    render: ({ canEdit }) => (
      <GeneralInformation data={client} refetch={fetchData} canEdit={canEdit} />
    ),
    name: 'General Information',
    route: `/vault/${client.id}/general-information`,
  },
  {
    render: ({ pathname, canEdit }) => (
      <ProgramCaseStatements
        data={client}
        pathname={pathname}
        refetch={fetchData}
        canEdit={canEdit}
      />
    ),
    name: 'Programs',
    route: `/vault/${client.id}/program-case-statements`,
  },
  {
    render: ({ canEdit }) => (
      <GovernanceStaff data={client} refetch={fetchData} canEdit={canEdit} />
    ),
    name: 'Governance and Staff',
    route: `/vault/${client.id}/governance-staff`,
  },
  {
    render: ({ canEdit }) => (
      <FiscalRegulatory data={client} refetch={fetchData} canEdit={canEdit} />
    ),
    name: 'Fiscal and Regulatory',
    route: `/vault/${client.id}/fiscal-regulatory`,
  },
  {
    render: ({ pathname, navigate, canEdit }) => (
      <Partnerships
        data={client}
        pathname={pathname}
        navigate={navigate}
        refetch={fetchData}
        canEdit={canEdit}
      />
    ),
    name: 'Partnerships',
    route: `/vault/${client.id}/partnerships`,
  },
  {
    render: ({ pathname, navigate, canEdit }) => (
      <AwardsRecognitionPublicity
        data={client}
        pathname={pathname}
        navigate={navigate}
        refetch={fetchData}
        canEdit={canEdit}
      />
    ),
    name: 'Awards, Recognition and Publicity',
    route: `/vault/${client.id}/awards-recognition-publicity`,
  },
  {
    render: ({ canEdit }) => (
      <Attachments data={client} refetch={fetchData} canEdit={canEdit} />
    ),
    name: 'Attachments',
    route: `/vault/${client.id}/attachments`,
  },
  {
    render: ({ pathname, navigate, canEdit }) => (
      <NotesVerbiage
        data={client}
        pathname={pathname}
        navigate={navigate}
        refetch={fetchData}
        canEdit={canEdit}
      />
    ),
    name: 'Notes and Verbiage',
    route: `/vault/${client.id}/notes-verbiage`,
  },
  {
    render: ({ canEdit }) => <Download data={client} canEdit={canEdit} />,
    name: 'Download',
    route: `/vault/${client.id}/download`,
  },
];
